<template>
<div container--fluid>
    <v-layout>
        <EftModule></EftModule>
    </v-layout>
</div>
</template>

<script>
import EftModule from '@modules/eft/index.vue';

export default {
    name: 'referee',
    components: {
        EftModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
